import { render, staticRenderFns } from "./UserCheckersQueue.vue?vue&type=template&id=6b436efa&"
import script from "./UserCheckersQueue.vue?vue&type=script&lang=js&"
export * from "./UserCheckersQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports